module.exports = __webpack_public_path__ + "img/hr-green-desert-bush-02.21f44763.png";